import { getPairedDevicesArr } from "src/modules/device/duck/selectors/index";

export function getEnabled(state) {
  return state.scheduler.enabled;
}

export function getTasks(state) {
  return state.scheduler.tasks;
}

export function getNotifyAllDevices(state) {
  return state.scheduler.notifyAllDevices;
}

export function getDevicesToNotify(state) {
  const notifyAllDevices = getNotifyAllDevices(state);

  const devices = notifyAllDevices
    ? getPairedDevicesArr(state)
        .filter((device) => {
          const deviceIndex = Number(device.jid.substr(device.jid.length - 1));
          return deviceIndex !== 4 && deviceIndex !== 9;
        })
        .reduce((all, one) => {
          all[one.jid] = one;
          return all;
        }, {})
    : state.scheduler.devicesToNotify;

  return devices;
}
